import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { Tooltip, Button, Modal, ModalHeader, ModalBody, Progress } from 'reactstrap';
import FD from '../../RestAPI/fetchData';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import App_data from '../../config/App_data';
import language from '../../../assets/languages/language';
import Loader from '../../../common/loader';
import AppRoutes from '../../config/AppRoutes';
import CfaSubscriptionCheck from '../../RestAPI/Cfa2Subscription';
import PartnerCfaSubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa2Subscription';
import { showFailure } from '../../../common/toast';
import { Y_AXIS_SCALES } from '../../../common/constant';
import { renderHTMLContent, renderSanitizedHTML } from '../../../common/function';
import EmailResubscribe from '../../../components/EmailResubscribe';
import {autorun} from "mobx";
import UserStore from "../../../store/userStore";
/* eslint-disable*/

var i = '';
class Cfa2Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      reportAnswerStatus: false,
      reportEditStatus: false,
      reportEditId: '',
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRM}`,
      items_val: '',
      item_status: '',
      dropdownOpen: false,
      ValidToken: false,

      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      token: '',
      idname: '',
      flashreport: [], //All Flash question Store
      savedquestion: [],
      reportquestion: [],
      progress_bar_zero: [],
      progress_bar: [],
      progress_bar_slider: [],
      main_bargraph_data: '',
      bar_chapter: '',
      activeTabFlashcards: '1',
      activeTabSaved: '1',
      activeTabReports: '1',
      bar_level_main: [
        'Ethics',
        'Quants',
        'Econ',
        'FRA',
        'Corpo',
        'Portfolio',
        'Equity',
        'Fixed Income',
        'Derivatives',
        'Al',
      ],
      bar_main_user: [],
      bar_main_class: [],
      startDate: '',
      startDate_second: '',
      send_startDate: '',
      send_startDate_second: '',
      more_detail_button: `${language.LC().I_WANT_MORE_DETAILS}`,
      show_outer: 'hide_block',
      chapters: '',
      subreadings_status: false,
      ErrorMessage: '',
      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
      tooltips: [
        {
          placement: `${language.LC().SEPARATE_YOUR_RESULT}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().YOU_CAN_SEE}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().THAT_SPECIFIC_NOTES}`,
          text_align: 'left',
        },
      ],
      display_main_loader: 'show_block',
      qpLoader: true,
      savedLoader: true,
      flashLoader: true,
      reportLoader: true,

      notesFlashReport: [],
      videoFlashReport: [],
      savednotes: [],
      savedvideo: [],
      reportnotes: [],
      reportsvideo: [],
      reportquestionCBT: [],
      isVideo: '',
      npLoader: true,
      selectedmenu: 'cfa_2',
    };
    this.handleChange = this.handleChange.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleClose = this.toggleClose.bind(this);
    this.toggleDone = this.toggleDone.bind(this);
    this.toggleCloseReport = this.toggleCloseReport.bind(this);
    this.toggleAlertReport = this.toggleAlertReport.bind(this);
    this.CloseEditQuesReport = this.CloseEditQuesReport.bind(this);
    this.OpenEditQuesReport = this.OpenEditQuesReport.bind(this);
    this.onContactChange = this.onContactChange.bind(this);
    this.CloseEditVideoReport = this.CloseEditVideoReport.bind(this);
    this.OpenEditNotesReport = this.OpenEditNotesReport.bind(this);
    this.OpenEditCBTQuesReport = this.OpenEditCBTQuesReport.bind(this);
    this.CloseEditNotesReport = this.CloseEditNotesReport.bind(this);
    this.OpenEditVideoReport = this.OpenEditVideoReport.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  toggleAlert(card) {
    this.setState({
      alert_status: !this.state.alert_status,
      item_status: card,
    });
  }

  toggleClose() {
    this.setState({
      alert_status: !this.state.alert_status,
      items_val: '',
      item_status: '',
    });
  }

  toggleAlertReport(item, type) {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: type === 'videoReport' ? item['cfa2_2025_video_reports.id'] : item.id,
      type: type,
    });
  }
  deleteFlashCard = async (type, id) => {
    const { idname: id_name, token } = this.state;
    const payload = {
      id_name,
      token,
      type: type,
      question_type: '',
      exam: 'cfa2_2025',
      level: '',
      item_id: id,
    };
    await FD.callAPI(`${App_data.backend_api}/question_bank_2024/deleteFlashCard`, payload);
  };
  // function to view cbt question
  view = (item) => {
    if (item.mockData) {
      let mock = JSON.parse(item.mockData);
      this.context.router.push({
        pathname: `/cfa2/2026/cbtquestionsfinish/${mock.mock_id}/${mock.caseId}/${item.question_id}/${
          mock.test_id
        }/${mock.caseOffset}/${mock.quesOffset}/${mock.timer}`,
      });
    }
  };
  toggleCloseReport() {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      ErrorMessage: '',
      contactStatus: false,
    });
  }

  OpenEditCBTQuesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      cbtquesReport: item.comment,
      type: 'cbtquesReport',
    });
  }
  toggleDone = async () => {
    const { idname, token, items_val, item_status } = this.state;
    const { question_id, item_id, video_id } = items_val;
    if (this.state.item_status == 'flashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/cfa_2_2025question_bank/deleteFlashCard',
        data,
      ).then(async (response) => {
        if (response.success) {
          await this.getQuestionFlashcards();
        }
      });
    }
    if (item_status == 'savedquestion') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      await this.deleteFlashCard('question', question_id ? question_id : item_id);
      await FD.callAPI(
        App_data.backend_api + '/cfa_2_2025question_bank/deleteSavequestion',
        data,
      ).then(async (response) => {
        if (response.success) {
          this.getQuestionSaved();
        }
      });
    }
    if (this.state.item_status == 'Reportsquestion') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/cfa_2_2025question_bank/deleteDashboardQuestionReports',
        data,
      ).then(async (response) => {
        if (response.success) {
          await this.getQuestionReports();
        }
      });
    }
    if (item_status == 'savednotes') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      await this.deleteFlashCard('notes', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/deleteSaveNotes', data).then(
        async (response) => {
          if (response.success) {
            await this.getNotesSaved();
          } else {
          }
        },
      );
    }

    if (item_status == 'savedvideos') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      await this.deleteFlashCard('video', video_id ? video_id : item_id);
      await FD.callAPI(
        App_data.backend_api + '/cfa_2_2025question_bank/deleteSaveVideo',
        data,
      ).then(async (response) => {
        if (response.success) {
          await this.getVideosSaved();
        } else {
        }
      });
    }

    if (this.state.item_status == 'Notesflashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/cfa2_2025_notes/deleteDashboardFlashCard',
        data,
      ).then(async (response) => {
        if (response.success) {
          await this.getNotesFlashcards();
        }
      });
    }

    if (this.state.item_status == 'Videoflashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/cfa_2_2025question_bank/deleteDashboardVideoFlashCard',
        data,
      ).then(async (response) => {
        if (response.success) {
          await this.getVideoFlashcards();
        }
      });
    }

    if (this.state.item_status == 'Reportsnotes') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/deleteDashboardNotesReports', data).then(
        async (response) => {
          if (response.success) {
            await this.getNotesReports();
          }
        },
      );
    }

    if (this.state.item_status == 'Reportsvideos') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/cfa_2_2025question_bank/deleteDashboardVideoReports',
        data,
      ).then(async (response) => {
        if (response.success) {
          await this.getVideoReports();
        }
      });
    }
    if (this.state.item_status == 'CBTreportsquestion') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/deleteReport', data).then(
        async (response) => {
          if (response.success) {
            await this.getCBTQestionReports();
          }
        },
      );
    }
    this.setState({
      alert_status: false,
    });
  };

  handleChange(date) {
    this.setState({
      startDate: date,
      startDate_second: '',
      send_startDate: moment(date).format('YYYY-MM-DD'),
      subreadings_status: false,
    });
  }
  handleChange_second(date) {
    if (this.state.startDate != '') {
      this.setState(
        {
          startDate_second: date,
          send_startDate_second: moment(date).format('YYYY-MM-DD'),
          subreadings_status: true,
          display_main_loader: 'show_block',
        },
        function afterdateChange() {
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            startDate: this.state.send_startDate,
            endDate: this.state.send_startDate_second,
          };
          // Get Notes Progress By User
          FD.callAPI(
            `${App_data.backend_api}/cfa_2_2025dashboard/getNotesProgressByUser`,
            data,
          ).then((response) => {
            const { notesProgress, success } = response;
            if (success) {
              this.setState({ progress_bar: notesProgress });
            }
          });
          FD.callAPI(
            `${App_data.backend_api}/cfa_2_2025dashboard/getQuestionProgressByUser`,
            data,
          ).then((response) => {
            const { questionProgress, success } = response;
            if (success) {
              this.setState({ bar_chapter: questionProgress });
              this.setState({ progress_bar_zero: questionProgress });
            }
          });
          // Get Main Progress Bar
          FD.callAPI(App_data.backend_api + '/cfa_2_2025dashboard/mainProgressbar', data).then(
            (response) => {
              if (response.success) {
                var dataString = JSON.stringify(response.chapters);
                var dataReason = JSON.parse(dataString);

                var final_array_main = [];

                for (i = 0; i < dataReason.length; i++) {
                  var right_answered = dataReason[i].answered_count;
                  var total_question = dataReason[i].attempted_count;

                  var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(
                    1,
                  );
                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }

                this.setState({
                  bar_main_user: final_array_main,
                  display_main_loader: 'hide_block',
                });
              } else {
                this.setState({ display_main_loader: 'hide_block' });
              }
            },
          );
          FD.callAPI(App_data.backend_api + '/cfa_2_2025dashboard/mainProgressclassbar', data).then(
            (response) => {
              if (response.success) {
                var dataString = JSON.stringify(response.chaptersclass);
                var dataReason = JSON.parse(dataString);
                var final_array_main = [];
                for (i = 0; i < dataReason.length; i++) {
                  var right_answered = dataReason[i].answered_count;
                  var total_question = dataReason[i].attempted_count;
                  var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(
                    1,
                  );

                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({ bar_main_class: final_array_main });
              }
            },
          );
        },
      );
    }
  }

  _deleteFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('flashcard');
  };

  _deleteSavequestion = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('savedquestion');
  };

  _deleteReportsquestino = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsquestion');
  };

  _getall = () => {
    if (this.state.show_outer == 'hide_block') {
      this.setState({ show_outer: 'show_block' });
      this.setState({ more_detail_button: 'Hide Details' });
    }
    if (this.state.show_outer == 'show_block') {
      this.setState({ show_outer: 'hide_block' });
      this.setState({ more_detail_button: 'I Want More Details' });
    }
  };

  async componentDidMount() {
    window.scroll(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };

    FD.callAPI(App_data.backend_api + '/user/authtoken', data).then((response) => {
      if (response.success) {
        this.setState({ ValidToken: true });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getChapters', data).then(
      (response) => {
        if (response.success) {
          this.setState({ ValidToken: true });
          this.setState({ chapters: response.chapters });
        } else {
          this.setState({ ValidToken: false });
        }
        return response;
      },
    );
    FD.callAPI(`${App_data.backend_api}/cfa_2_2025dashboard/getQuestionProgressByUser`, data).then(
      (response) => {
        const { success, questionProgress } = response;
        if (success) {
          this.setState({
            progress_bar_zero: questionProgress,
            qpLoader: false,
          });
          this.setState({ bar_chapter: questionProgress });
        }
      },
    );

    FD.callAPI(App_data.backend_api + '/cfa_2_2025dashboard/mainProgressbar', data).then(
      (response) => {
        if (response.success) {
          this.setState({ display_main_loader: 'hide_block' });
          var dataString = JSON.stringify(response.chapters);
          var dataReason = JSON.parse(dataString);
          var final_array_main = [];
          for (i = 0; i < dataReason.length; i++) {
            var right_answered = dataReason[i].answered_count;
            var total_question = dataReason[i].attempted_count;
            var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);
            final_array_main.push(user_graph_val);
          }
          this.setState({ bar_main_user: final_array_main });
        }
      },
    );

    this.setState({ display_main_loader: 'show_block' });



    FD.callAPI(App_data.backend_api + '/cfa_2_2025dashboard/mainProgressclassbar', data).then(
      (response) => {
        if (response.success) {
          var dataString = JSON.stringify(response.chaptersclass);
          var dataReason = JSON.parse(dataString);

          var final_array_main = [];

          for (i = 0; i < dataReason.length; i++) {
            var right_answered = dataReason[i].answered_count;
            var total_question = dataReason[i].attempted_count;

            var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);
            final_array_main.push(user_graph_val);
          }
          this.setState({ bar_main_class: final_array_main });
        }
      },
    );

    // --------------------------------- START -----------------------------------

    // A workaround for old functionality
    this.dispose = autorun(async () => {
      const response = UserStore;
      if(response == null || response.profileInfo == null){
        return;
      }

      if (response.profileInfo) {
        this.setState({
          isVideo: response.profileInfo.isVideo,
        });
      }
      if (response.profileInfo ? response.profileInfo.role === 'partner' : 0) {
        if (
            response.profileInfo.exam_selected === '' &&
            response.profileInfo.exam_package === ''
        ) {
          this.setState({
            showFreePremium: true,
          });
        } else {
          var subscription_details = response.profileInfo.subscription_details
              ? JSON.parse(response.profileInfo.subscription_details)
              : response.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam,
          });

          var data_arr = response.profileInfo.exam_selected
              ? JSON.parse(response.profileInfo.exam_selected)
              : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async (resp_exam) => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = await PartnerCfaSubscriptionCheck.checkCfa2Subscription(
                      selectedmen,
                      exam_data,
                      this.state.cfaUnlimitedPackage,
                      this.state.cfaUnlimitedActiveExam,
                  );
                  if (isInArray_var) {
                    this.setState({showFreePremium: false});
                  } else {
                    this.setState({showFreePremium: true});
                  }
                  if (!isInArray_var) {
                    isInArray_var = PartnerCfaSubscriptionCheck.checkCfa2VideosSubscription(
                        selectedmen,
                        exam_data,
                        this.state.cfaUnlimitedPackage,
                        this.state.cfaUnlimitedActiveExam,
                    );
                    if (isInArray_var) {
                      this.setState({showFreePremium: false});
                    } else {
                      this.setState({showFreePremium: true});
                    }
                  }
                } else {
                }
              },
          );
        }
      } else {
        if (
            response.profileInfo.exam_selected === '' &&
            response.profileInfo.cfaUnlimitedPackage == '' &&
            response.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          this.setState({
            showFreePremium: true,
          });
        } else {
          var subscription_details = response.profileInfo.subscription_details
              ? JSON.parse(response.profileInfo.subscription_details)
              : response.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = response.profileInfo.exam_selected
              ? JSON.parse(response.profileInfo.exam_selected)
              : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              (resp_exam) => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = CfaSubscriptionCheck.checkCfa2Subscription(
                      selectedmen,
                      exam_data,
                      this.state.cfaUnlimitedPackage,
                      this.state.cfaUnlimitedActiveExam,
                  );
                  if (isInArray_var) {
                    this.setState({showFreePremium: false});
                  } else {
                    this.setState({showFreePremium: true});
                  }
                  if (!isInArray_var) {
                    isInArray_var = CfaSubscriptionCheck.checkCfa2VideosSubscription(
                        selectedmen,
                        exam_data,
                        this.state.cfaUnlimitedPackage,
                        this.state.cfaUnlimitedActiveExam,
                    );
                    if (isInArray_var) {
                      this.setState({showFreePremium: false});
                    } else {
                      this.setState({showFreePremium: true});
                    }
                  }
                } else {
                }
              },
          );
        }
      }

    });

    // const getProfileInfoData = {
    //   token: storage_session['token'],
    //   idname: storage_session['idname'],
    // };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfoData).then(
    //   async (response) => {
    //     if (response.profileInfo) {
    //       this.setState({
    //         isVideo: response.profileInfo.isVideo,
    //       });
    //     }
    //     if (response.profileInfo ? response.profileInfo.role === 'partner' : 0) {
    //       if (
    //         response.profileInfo.exam_selected === '' &&
    //         response.profileInfo.exam_package === ''
    //       ) {
    //         this.setState({
    //           showFreePremium: true,
    //         });
    //       } else {
    //         var subscription_details = response.profileInfo.subscription_details
    //           ? JSON.parse(response.profileInfo.subscription_details)
    //           : response.profileInfo.subscription_details;
    //
    //         this.setState({
    //           subscription_details: subscription_details,
    //           cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
    //           cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam,
    //         });
    //
    //         var data_arr = response.profileInfo.exam_selected
    //           ? JSON.parse(response.profileInfo.exam_selected)
    //           : null;
    //         var dataset = {
    //           token: this.state.token,
    //           idname: this.state.idname,
    //           examid: data_arr,
    //         };
    //         await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
    //           async (resp_exam) => {
    //             if (resp_exam.success) {
    //               var exam_data = resp_exam.examData;
    //               var selectedmen = this.state.selectedmenu;
    //               var isInArray_var = false;
    //               isInArray_var = await PartnerCfaSubscriptionCheck.checkCfa2Subscription(
    //                 selectedmen,
    //                 exam_data,
    //                 this.state.cfaUnlimitedPackage,
    //                 this.state.cfaUnlimitedActiveExam,
    //               );
    //               if (isInArray_var) {
    //                 this.setState({ showFreePremium: false });
    //               } else {
    //                 this.setState({ showFreePremium: true });
    //               }
    //               if (!isInArray_var) {
    //                 isInArray_var = PartnerCfaSubscriptionCheck.checkCfa2VideosSubscription(
    //                   selectedmen,
    //                   exam_data,
    //                   this.state.cfaUnlimitedPackage,
    //                   this.state.cfaUnlimitedActiveExam,
    //                 );
    //                 if (isInArray_var) {
    //                   this.setState({ showFreePremium: false });
    //                 } else {
    //                   this.setState({ showFreePremium: true });
    //                 }
    //               }
    //             } else {
    //             }
    //           },
    //         );
    //       }
    //     } else {
    //       if (
    //         response.profileInfo.exam_selected === '' &&
    //         response.profileInfo.cfaUnlimitedPackage == '' &&
    //         response.profileInfo.cfaUnlimitedActiveExam == ''
    //       ) {
    //         this.setState({
    //           showFreePremium: true,
    //         });
    //       } else {
    //         var subscription_details = response.profileInfo.subscription_details
    //           ? JSON.parse(response.profileInfo.subscription_details)
    //           : response.profileInfo.subscription_details;
    //
    //         this.setState({
    //           subscription_details: subscription_details,
    //           cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
    //           cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam,
    //         });
    //         var data_arr = response.profileInfo.exam_selected
    //           ? JSON.parse(response.profileInfo.exam_selected)
    //           : null;
    //         var dataset = {
    //           token: this.state.token,
    //           idname: this.state.idname,
    //           examid: data_arr,
    //         };
    //         await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
    //           (resp_exam) => {
    //             if (resp_exam.success) {
    //               var exam_data = resp_exam.examData;
    //               var selectedmen = this.state.selectedmenu;
    //               var isInArray_var = false;
    //               isInArray_var = CfaSubscriptionCheck.checkCfa2Subscription(
    //                 selectedmen,
    //                 exam_data,
    //                 this.state.cfaUnlimitedPackage,
    //                 this.state.cfaUnlimitedActiveExam,
    //               );
    //               if (isInArray_var) {
    //                 this.setState({ showFreePremium: false });
    //               } else {
    //                 this.setState({ showFreePremium: true });
    //               }
    //               if (!isInArray_var) {
    //                 isInArray_var = CfaSubscriptionCheck.checkCfa2VideosSubscription(
    //                   selectedmen,
    //                   exam_data,
    //                   this.state.cfaUnlimitedPackage,
    //                   this.state.cfaUnlimitedActiveExam,
    //                 );
    //                 if (isInArray_var) {
    //                   this.setState({ showFreePremium: false });
    //                 } else {
    //                   this.setState({ showFreePremium: true });
    //                 }
    //               }
    //             } else {
    //             }
    //           },
    //         );
    //       }
    //     }
    //   },
    // );

    await FD.callAPI(
      `${App_data.backend_api}/cfa_2_2025dashboard/getNotesProgressByUser`,
      data,
    ).then(async (response) => {
      const { success, notesProgress } = response;
      if (response.success) {
        this.setState({
          progress_bar: response.notesProgress,
          npLoader: false,
        });
      }
    });
    // --------------------------------- End -------------------------------------
    await this.getQuestionFlashcards();
    await this.getQuestionSaved();
    this.getQuestionReports();

    await this.getNotesFlashcards();
    await this.getNotesSaved();
    await this.getNotesReports();
    await this.getVideoFlashcards();
    await this.getVideosSaved();
    await this.getVideoReports();
    await this.getCBTQestionReports();
  }

  componentWillUnmount() {
    if (this.dispose) this.dispose();
  }

  // function for get  question report
  getQuestionReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_2_2025question_bank/getReportsQuestionsbyuserid',
      data,
    ).then(async (response) => {
      if (response.success) {
        this.setState({ reportquestion: response.questions, reportLoader: false });
      }
    });
  };

  // function for get  question FlashCard
  getQuestionFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
  };

  // function for get  question report
  getQuestionSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_2_2025question_bank/getFavQuestionsbyuserid',
      data,
    ).then((response) => {
      if (response.success) {
        this.setState({ savedquestion: response.questions, savedLoader: false });
      }
    });
  };

  _beginChapter = (item, e) => {
    let isActiveQues = false;
    let isActiveCases = false;
    let isActive = false;

    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.question_id,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getQuestionsbyid', data).then(
      (response) => {
        if (response.success) {
          isActiveQues = response.questionsbyid.isActive2025;
          var dataparam = {
            token: this.state.token,
            idname: this.state.idname,
            caseid: response.questionsbyid.case_id,
          };
          FD.callAPI(
            App_data.backend_api + '/cfa_2_2025question_bank/getCasesbyId',
            dataparam,
          ).then(async (resp_case) => {
            if (resp_case.success) {
              isActiveCases = resp_case.casesingleData.isActive2025;
              let indexcase = -1;
              const caseReadings = await FD.callAPI(
                App_data.backend_api + '/cfa_2_2025question_bank/getCases',
                {
                  token: this.state.token,
                  idname: this.state.idname,
                  chapter_id: resp_case.casesingleData.chapter_no_2025,
                },
              );
              caseReadings.readings.map((value, index) => {
                if (value.id === resp_case.casesingleData.id) {
                  isActive = value.isActive2025;
                  indexcase = index;
                }
              });
              if (isActive && isActiveCases && isActiveQues) {
                this.context.router.push({
                  pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(
                    ':chapterid',
                    response.questionsbyid.chapter_id_2025,
                  )
                    .replace(':caseid', response.questionsbyid.case_id)
                    .replace(':case_offset', indexcase)
                    .replace(':question_number', response.questionsbyid.question_number),
                });
              } else {
                showFailure('Questions unavailable');
              }
            } else {
              showFailure('Questions unavailable');
            }
          });
        } else {
          showFailure('Questions unavailable');
        }
      },
    );
  };
  questionProgressBarFun() {
    return this.state.progress_bar_zero.map((item, index) => {
      var progressnotes_zero = Math.round((item.totalQuestions / item.attemptedQuestions) * 100);
      if (progressnotes_zero < 1) {
        progressnotes_zero = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>
                {language.LC().Q}
                {item.id}
              </div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes_zero}
                      style={{ width: progressnotes_zero + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }

  OpenEditQuesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      quesReport: item.comment,
    });
  }

  CloseEditQuesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      quesReport: '',
      ErrorMessage: '',
    });
  }

  // question form submit function
  async handleQuestionReportSubmit(event) {
    event.preventDefault();
    if (this.state.quesReport === '' && this.state.quesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, quesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      quesReport: quesReport,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_2_2025question_bank/UpdateReportsQuestionsbyuserid',
      data,
    ).then(async (response) => {
      if (response.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          quesReport: '',
        });
        await this.getQuestionReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return response;
    });
  }

  // function for state change of edit report form fileds
  InputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      ErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  SubjectInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      SubjectErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  CommentInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      CommentErrorMessage: '',
    });
  }

  onContactChange(data, index, type) {
    if (!this.state.contactStatus) {
      this.setState({
        contactID: type === 'videoReport' ? data['cfa2_2025_video_reports.id'] : data.id,
        contactIndex: index,
        contactStatus: true,
        contactType: type,
      });
    } else {
      this.setState({
        contactID: '',
        contactType: '',
        contactIndex: '',
        contactSubject: '',
        contactComment: '',
        SubjectErrorMessage: '',
        CommentErrorMessage: '',
        contactStatus: false,
      });
    }
  }

  onContactSubmit = async (event) => {
    event.preventDefault();
    if (this.state.contactSubject === '' && this.state.contactSubject.length < 1) {
      this.setState({
        displaytext: 'show_block',
        SubjectErrorMessage: "Subject can't be empty",
        isLoading: false,
      });
      return;
    }
    if (this.state.contactComment === '' && this.state.contactComment.length < 1) {
      this.setState({
        displaytext: 'show_block',
        CommentErrorMessage: "Comment can't be empty",
        isLoading: false,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    const { idname, token, contactComment, contactSubject } = this.state;
    const data = {
      idname: idname,
      token: token,
      contactComment: contactComment,
      contactSubject: contactSubject,
    };
    await FD.callAPI(App_data.backend_api + '/contact_us/sendReportHelpRequest', data).then(
      async (response) => {
        if (response.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            isLoading: false,
            successAlert: true,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return response;
      },
    );
  };

  onClose = (e) => {
    this.setState({
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      type: '',
    });
  };

  flashcardTabToggle = (tab) => {
    if (this.state.activeTabFlashcards !== tab) {
      this.setState({
        activeTabFlashcards: tab,
      });
    }
  };

  savedTabToggle = (tab) => {
    if (this.state.activeTabSaved !== tab) {
      this.setState({
        activeTabSaved: tab,
      });
    }
  };

  reportsTabToggle = (tab) => {
    if (this.state.activeTabReports !== tab) {
      this.setState({
        activeTabReports: tab,
      });
    }
  };

  CloseEditVideoReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      videoReport: '',
      type: '',
      ErrorMessage: '',
    });
  }
  CloseEditNotesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      notesReport: '',
      type: '',
      ErrorMessage: '',
    });
  }
  OpenEditVideoReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item['cfa2_2025_video_reports.id'],
      videoReport: item['cfa2_2025_video_reports.comment'],
      type: 'videoReport',
    });
  }
  OpenEditNotesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      notesReport: item.comment,
      type: 'notesReport',
    });
  }
  // function for get  notes report
  getNotesSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/getFavNotesbyuserid', data).then(
      async (response) => {
        if (response.success) {
          this.setState({ savednotes: response.cfa_notes });
        }
      },
    );
  };

  // function for get  notes report
  getNotesFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
  };

  // function for get  Video falshCard
  getVideoFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
  };

  // function for get  video report
  getVideoReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_2_2025question_bank/getReportsVideobyuserid',
      data,
    ).then(async (response) => {
      if (response.success) {
        this.setState({ reportsvideo: response.video });
      }
    });
  };

  /*
   * get saved all video
   */
  getVideosSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_2_2025question_bank/getFavVideosbyuserid',
      data,
    ).then(async (response) => {
      if (response.success) {
        this.setState({ savedvideo: response.cfa_videos });
      }
    });
  };

  // function for get  notes report
  getNotesReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/getReportsNotesbyuserid', data).then(
      async (response) => {
        if (response.success) {
          this.setState({ reportnotes: response.notes });
        }
      },
    );
  };
  notesProgressBarFun() {
    return this.state.progress_bar.map((item, index) => {
      var progresstotalques = item.totalNotes;
      var progressnotes = Math.round((item.attemptedNotes / progresstotalques) * 100);
      if (progressnotes < 1) {
        progressnotes = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>N.{item.chapter_id_2025}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes}
                      style={{ width: progressnotes + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }
  _beginVideos = async (reading, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading['cfa2_2025_video_reports.video_id']
        ? reading['cfa2_2025_video_reports.video_id']
        : reading.video_id,
    };
    await FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getVideoByID', data).then(
      (response) => {
        if (response.success) {
          let data = response.allVideo.findIndex((item) => item.id === response.video[0].id);
          if (response.video[0].isActive2025) {
            // This handles both `true` and `1`
            if (response.video[0].mock_id) {
              this.context.router.push({
                pathname: AppRoutes.CFA2_2026_VIDEOS_LIST.replace(':id', response.video[0].id).replace(
                  ':chapterId',
                  response.video[0].chapter_id_2025,
                ),
                query: { mockId: response.video[0].mock_id },
              });
            } else {
              this.context.router.push({
                pathname: AppRoutes.CFA2_2026_VIDEOS_LIST.replace(':id', response.video[0].id).replace(
                  ':chapterId',
                  response.video[0].chapter_id_2025,
                ),
              });
            }
          } else {
            showFailure('Videos unavailable');
          }
        } else {
          showFailure('Videos unavailable');
        }
      },
    );
  };
  // notes form submit function
  async handleNotesReportSubmit(event) {
    event.preventDefault();
    if (this.state.notesReport === '' && this.state.notesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, notesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      notesReport: notesReport,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa2_2025_notes/UpdateReportsNotesbyuserid',
      data,
    ).then(async (response) => {
      if (response.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          notesReport: '',
        });
        await this.getNotesReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return response;
    });
  }
  // video form submit function
  async handleVideoReportSubmit(event) {
    event.preventDefault();
    if (this.state.videoReport === '' && this.state.videoReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, videoReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      videoReport: videoReport,
    };
    await FD.callAPI(
      App_data.backend_api + '/cfa_2_2025question_bank/UpdateReportsVideobyuserid',
      data,
    ).then(async (response) => {
      if (response.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          videoReport: '',
        });
        await this.getVideoReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return response;
    });
  }
  /*
   * function for go to specific notes main page
   */
  _beginNotes = async (reading, e) => {
    let isActive2025 = false;
    var reading_id = '';
    var chapter_id = '';
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading.question_id,
    };
    let offset = 0;
    await FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/getNotesByID', data).then(
      (response) => {
        if (response.success) {
          isActive2025 = response.notes[0].isActive2025;
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            chapter_id: response.notes[0].chapter_id_2025,
            reading_id: response.notes[0].reading_id_2025,
            offset: this.state.offset,
          };
          chapter_id = response.notes[0].chapter_id_2025;
          if (isActive2025 || isActive2025 == 1) {
            FD.callAPI(App_data.backend_api + '/cfa2_2025_notes/getNotes_allcr', data).then(
              async (response) => {
                if (response.success) {
                  for (var i = 0; i < response.questions.length; i++) {
                    if (response.questions[i].id === reading.question_id) {
                      offset = i;
                      this.context.router.push({
                        pathname: `${AppRoutes.CFA2_2025_BEGIN_NOTES}`
                          .replace(':notesid', chapter_id)
                          .replace(':readingid', response.questions[i].reading_id_2025)
                          .replace(':id', reading.question_id)
                          .replace(':offset', offset),
                      });
                      break;
                    }
                  }
                }
              },
            );
          } else {
            showFailure('Notes unavailable');
          }
        }
      },
    );
  };
  _deleteNotesFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Notesflashcard');
  };
  _deleteVideoFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Videoflashcard');
  };
  _deleteSaveNotes = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('savednotes');
  };
  _deleteSaveVideo = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('savedvideos');
  };
  _deleteReportsNotes = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsnotes');
  };
  _deleteReportsVideo = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsvideos');
  };
  _deleteCBTReportsquestino = (items) => {
    this.setState({ items_val: items });
    this.toggleAlert('CBTreportsquestion');
  };
  // function to get cbt question reports
  getCBTQestionReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/getreportedQuestion', data).then(
      async (response) => {
        if (response.success) {
          this.setState({
            reportquestionCBT: response.questions,
            reportLoader: false,
          });
        }
      },
    );
  };

  async handleCBTQuestionReportSubmit(event) {
    event.preventDefault();
    if (this.state.cbtquesReport === '' && this.state.cbtquesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, cbtquesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      quesReport: cbtquesReport,
    };
    await FD.callAPI(App_data.backend_api + '/cfa2CBTMockExams/updateReport', data).then(
      async (response) => {
        if (response.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId: '',
            cbtquesReport: '',
          });
          await this.getCBTQestionReports();
        } else {
          this.setState({ ValidToken: false });
        }
        return response;
      },
    );
  }

  render() {
    const {
      activeTabFlashcards,
      activeTabSaved,
      activeTabReports,
      qpLoader,
      savedLoader,
      flashLoader,
      reportLoader,
      isVideo,
      npLoader,
    } = this.state;
    let flashreport_val = this.state.flashreport;
    let savedquestion_val = this.state.savedquestion;
    let reportquestion_val = this.state.reportquestion;
    let progress_bar_zero_val = this.state.progress_bar_zero;

    let notes_flashreport_val = this.state.notesFlashReport;
    let video_flashreport_val = this.state.videoFlashReport;
    let savednotes_val = this.state.savednotes;
    let savedvideo_val = this.state.savedvideo;
    let reportnotes_val = this.state.reportnotes;
    let reportvideo_val = this.state.reportsvideo;
    let notes_flashcard_data = '';
    let video_flashcard_data = '';
    let savednotes_data = '';
    let savedvideo_data = '';
    let notes_reportsData = ''; // for notes report
    let video_reportsData = ''; // for video report

    let flashcard_data = '';
    let savedquestion_data = '';
    let question_reportsData = ''; // for question reports
    let reportquestionCBT_val = this.state.reportquestionCBT;
    let cbt_reportsData = ''; // for cbt question reports
    let progress_bar_data = '';
    /*first main graph*/
    let main_bar_val = this.state.bar_chapter;
    let main_bar_percentage = this.state.bar_main_user;
    let main_bar_user_percentage = this.state.bar_main_class;
    let main_bar_data = [];
    var i = 0;

    Object.keys(main_bar_val).map(function (key) {
      var dataString = JSON.stringify(main_bar_val[key]);
      var dataReason = JSON.parse(dataString);
      main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
      var chapter_id = dataReason.chapter_id;

      i++;
    });

    var bar_data = {
      labels: main_bar_data,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: main_bar_percentage,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: main_bar_user_percentage,
        },
      ],
    };

    const savQuestionTabs = [
      { id: '1', label: language.LC().QUESTIONS },
      { id: '2', label: language.LC().Notes },
      isVideo && { id: '3', label: language.LC().VIDEOS },
    ].filter(Boolean);

    const tabs = [
      { id: '1', label: language.LC().QUESTIONS },
      { id: '2', label: language.LC().Notes },
      isVideo && { id: '3', label: language.LC().VIDEOS },
      { id: '4', label: 'Mocks' },
    ].filter(Boolean);

    let chapters = this.state.chapters;
    let reading_data = '';

    if (this.state.flashreport.length) {
      flashcard_data = flashreport_val.map((items, index) => (
        <div id={'flash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else if (flashLoader) {
      flashcard_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.notesFlashReport.length) {
      notes_flashcard_data = notes_flashreport_val.map((items, index) => (
        <div id={'notesFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteNotesFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else {
      notes_flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }
    if (this.state.videoFlashReport.length) {
      video_flashcard_data = video_flashreport_val.map((items, index) => (
        <div id={'videoFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginVideos.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteVideoFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else {
      video_flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.savedquestion.length) {
      savedquestion_data = savedquestion_val.map((items, index) => (
        <div id={'savedque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSavequestion.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong> {language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>
        </div>
      ));
    } else if (savedLoader) {
      savedquestion_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      savedquestion_data = <div className='text-center'>{language.LC().NO_SAVED_QUESTIONS}</div>;
    }

    if (this.state.reportquestion.length) {
      question_reportsData = reportquestion_val.map((items, index) => (
        <div id={'reportsque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditQuesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={this.state.reportEditStatus && this.state.reportEditId === items.id}
              toggle={this.OpenEditQuesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditQuesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleQuestionReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='quesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.quesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditQuesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items)}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={this.state.reportAnswerStatus && this.state.reportAnswerId === items.id}
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index)}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index)}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactID === items.id &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>{renderHTMLContent(items.answer, 'span')}</p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsquestino.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            {renderHTMLContent(items.comment, 'span')}
          </p>
        </div>
      ));
    } else if (reportLoader) {
      question_reportsData = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      question_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.savednotes.length) {
      savednotes_data = savednotes_val.map((items, index) => (
        <div id={'savednotes_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSaveNotes.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items['cfa2_note.name_2025'] && (
              <div>
                <strong> {language.LC().TOPIC}: </strong>
                {renderHTMLContent(items['cfa2_note.name_2025'], 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>
        </div>
      ));
    } else {
      savednotes_data = <div className='text-center'> {language.LC().NO_SAVED_NOTES} </div>;
    }
    if (this.state.savedvideo.length) {
      savedvideo_data = savedvideo_val.map((items, index) => (
        <div id={'savedvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginVideos.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSaveVideo.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items['cfa2_video.title'] && (
              <div>
                <strong> {language.LC().TOPIC}: </strong>
                {renderHTMLContent(items['cfa2_video.title'], 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>
        </div>
      ));
    } else {
      savedvideo_data = <div className='text-center'> {language.LC().NO_SAVED_VIDEO} </div>;
    }

    if (this.state.reportnotes.length) {
      notes_reportsData = reportnotes_val.map((items, index) => (
        <div id={'reportsnotes_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            {' '}
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditNotesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'notesReport'
              }
              toggle={this.OpenEditNotesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id} {renderHTMLContent(items['cfa2_note.name_2025'], 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditNotesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleNotesReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='notesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.notesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditNotesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            {items.isSend && items.reply ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'notesReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'notesReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id} {renderHTMLContent(items['cfa2_note.name_2025'], 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactType === 'notesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'notesReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'notesReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{
                      paddingLeft: '0.5rem',
                      paddingTop: '0.5rem',
                    }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactType === 'notesReport' &&
                this.state.contactID === items.id &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.reply)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsNotes.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items['cfa2_note.name_2025'], 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else {
      notes_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportsvideo.length) {
      video_reportsData = reportvideo_val.map((items, index) => (
        <div
          id={'reportsvideos_' + items['cfa2_2025_video_reports.id']}
          key={index}
          className='flash_card_box'
        >
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items['cfa2_2025_video_reports.id']}
            </span>

            <span
              className={`float-right status-${
                items['cfa2_2025_video_reports.status'] === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items['cfa2_2025_video_reports.status'] === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>
          <div className='mt-1'>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong>{' '}
              {items['cfa2_2025_video_reports.video_id']}
            </span>
            {!items['cfa2_2025_video_reports.isSend'] &&
            !items['cfa2_2025_video_reports.reply'] &&
            items['cfa2_2025_video_reports.status'] !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditVideoReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items['cfa2_2025_video_reports.id'] &&
                this.state.type === 'videoReport'
              }
              toggle={this.OpenEditVideoReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items['cfa2_2025_video_reports.video_id']}{' '}
                {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditVideoReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleVideoReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='videoReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.videoReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditVideoReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginVideos.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items['cfa2_2025_video_reports.reply'] ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'videoReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items['cfa2_2025_video_reports.id'] &&
                this.state.type === 'videoReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items['cfa2_2025_video_reports.video_id']}{' '}
                <span>{renderSanitizedHTML(items.topic_name)}</span>
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactType === 'videoReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{
                      paddingLeft: '0.5rem',
                      paddingTop: '0.5rem',
                    }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactType === 'videoReport' &&
                this.state.contactID === items['cfa2_2025_video_reports.id'] &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items['cfa2_2025_video_reports.reply'])}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsVideo.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items['cfa2_2025_video_reports.comment'])}</span>
          </p>
        </div>
      ));
    } else {
      video_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }
    if (this.state.reportquestionCBT.length) {
      cbt_reportsData = reportquestionCBT_val.map((items, index) => {
        let parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
        let mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
        return (
          <div id={'reportsque_' + items.id} key={index} className='flash_card_box'>
            <div>
              <span>
                <strong> {language.LC().TICKET_ID}: </strong> {items.id}
              </span>

              <span
                className={`float-right status-${
                  items.status === 'resolved' ? 'resolved' : 'pending'
                }`}
              >
                <strong className='text-capitalize'>
                  {items.status === 'resolved' ? 'resolved' : 'pending'}
                </strong>
              </span>
            </div>

            <div className='mt-1'>
              <span>
                <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
              </span>
              {!items.isSend && !items.answer && items.status !== 'resolved' ? (
                <span
                  className='up tooltip-hover-questions float-right'
                  style={{ padding: '10px' }}
                  onClick={items.isSend ? null : this.OpenEditCBTQuesReport.bind(this, items)}
                  disabled={items.isSend}
                >
                  <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                  <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                    {' '}
                  </i>
                </span>
              ) : null}
              <Modal
                isOpen={
                  this.state.reportEditStatus &&
                  this.state.reportEditId === items.id &&
                  this.state.type === 'cbtquesReport'
                }
                toggle={this.OpenEditCBTQuesReport}
                className={'modal-primary ' + this.props.className}
              >
                <ModalHeader>
                  Q. {items.question_id} {renderHTMLContent(mockName, 'span')}
                  <Button className='close' color='secondary' onClick={this.CloseEditCBTQuesReport}>
                    ×
                  </Button>
                </ModalHeader>
                <ModalBody>
                  <div className='card-block'>
                    <form onSubmit={this.handleCBTQuestionReportSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <textarea
                            id='comment'
                            name='cbtquesReport'
                            rows='6'
                            className='form-control'
                            placeholder='Content..'
                            onChange={this.InputChange.bind(this)}
                            value={this.state.cbtquesReport}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.ErrorMessage}
                          </span>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-12 d-flex'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {language.LC().UPDATE}
                          </button>

                          <button
                            type='button'
                            className='btn btn-danger active pointer_class margin_left_10'
                            onClick={this.CloseEditCBTQuesReport}
                          >
                            {' '}
                            {language.LC().CANCEL}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </ModalBody>
              </Modal>

              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW} </div>
                <i
                  onClick={() => this.view(items)}
                  className={this.state.viewCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>

              {items.isSend && items.reply && items.reply.length > 0 ? (
                <span
                  className='up tooltip-hover-questions float-right'
                  style={{ padding: '10px' }}
                >
                  <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                  <i
                    onClick={this.toggleAlertReport.bind(this, items, 'cbtquesReport')}
                    className={this.state.viewREPORTCSS}
                    style={{ color: '#1f8ceb' }}
                  />
                </span>
              ) : null}
              <Modal
                isOpen={
                  this.state.reportAnswerStatus &&
                  this.state.reportAnswerId === items.id &&
                  this.state.type === 'cbtquesReport'
                }
                toggle={this.toggleAlertReport}
                className={'modal-primary ' + this.props.className}
              >
                <ModalHeader>
                  Q. {items.question_id} <span>{renderSanitizedHTML(items.topic_name)}</span>
                  <div className='contact-us-btn float-right'>
                    {this.state.contactStatus &&
                    this.state.contactType === 'cbtquesReport' &&
                    this.state.contactID === items.id &&
                    this.state.contactIndex === index ? (
                      <Button
                        className='btn btn-primary'
                        onClick={this.onContactChange.bind(this, items, index, 'cbtquesReport')}
                      >
                        {language.LC().GO_TO_ANSWER}{' '}
                      </Button>
                    ) : (
                      <Button
                        className='btn btn-primary'
                        onClick={this.onContactChange.bind(this, items, index, 'cbtquesReport')}
                      >
                        {' '}
                        <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                        {language.LC().I_need_further_help}{' '}
                      </Button>
                    )}
                    <Button
                      className='close'
                      style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                      color='secondary'
                      onClick={this.toggleCloseReport}
                    >
                      ×
                    </Button>
                  </div>
                </ModalHeader>
                <ModalBody>
                  {this.state.contactStatus &&
                  this.state.contactType === 'cbtquesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    !this.state.successAlert ? (
                      <form onSubmit={this.onContactSubmit.bind(this)}>
                        <div className='row'>
                          <div className='col-sm-12 margin_bottom_10'>
                            <h6 className='mb-1 d-flex'>
                              {' '}
                              {language.LC().SUBJECT}{' '}
                              <span className={this.state.displaytext + ' text-danger'}>*</span>
                            </h6>
                            <textarea
                              id='contactSubject'
                              name='contactSubject'
                              rows='2'
                              className='form-control'
                              placeholder='Subject..'
                              onChange={this.SubjectInputChange.bind(this)}
                              value={this.state.contactSubject}
                            />
                            <span className={this.state.displaytext + ' text-danger'}>
                              {this.state.SubjectErrorMessage}
                            </span>
                          </div>
                          <div className='col-sm-12 margin_bottom_10'>
                            <h6 className='mb-1 d-flex'>
                              {' '}
                              {language.LC().COMMENT}{' '}
                              <span className={this.state.displaytext + ' text-danger'}>*</span>
                            </h6>
                            <textarea
                              id='contactComment'
                              name='contactComment'
                              rows='6'
                              className='form-control'
                              placeholder='Comment..'
                              onChange={this.CommentInputChange.bind(this)}
                              value={this.state.contactComment}
                            />
                            <span className={this.state.displaytext + ' text-danger'}>
                              {this.state.CommentErrorMessage}
                            </span>
                          </div>
                          <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                            <button type='submit' className='btn btn-primary active pointer_class'>
                              {' '}
                              {this.state.isLoading
                                ? 'Please wait ...'
                                : language.LC().SEND_REQUEST}
                            </button>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className='text-center'>
                      <p className='margin_bottom_20'>
                        <span>{renderSanitizedHTML(items.reply)}</span>
                      </p>
                    </div>
                  )}
                </ModalBody>
              </Modal>
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().DELETE} </div>
                <i
                  onClick={this._deleteCBTReportsquestino.bind(this, items)}
                  className={this.state.deleteCSS}
                  style={{ color: '#f51a00' }}
                >
                  {' '}
                </i>
              </span>
            </div>
            <p className='mt-1'>
              <strong> {language.LC().REPORT}: </strong>
              <span>{renderSanitizedHTML(items.comment)}</span>
            </p>
          </div>
        );
      });
    } else {
      cbt_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }
    return (
      <div>
        <div className='animated fadeIn'>
          <EmailResubscribe />
          <div className='row'>
            <div className='col-sm-12 col-md-12 margin_bottom_20'>
              <h1 className='section_head'>{language.LC().CFA_LEVEL_II_2023_DASHBOARD}</h1>
            </div>
            <div className='col-lg-8'>
              <div className='card margin_bottom_20'>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-1 text-md-right align-self-center'>
                      <label className='margin_bottom_0'>{language.LC().FROM}</label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          selected={this.state.startDate}
                          onChange={this.handleChange}
                          placeholderText='Select date'
                          width='100%'
                        />
                      </div>
                    </div>
                    <div className='col-sm-1 text-md-center align-self-center'>
                      <label className='margin_bottom_0'>{language.LC().TO}</label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          placeholderText='Select date'
                          width='100%'
                          selected={this.state.startDate_second}
                          minDate={this.state.startDate}
                          onChange={this.handleChange_second.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().PERFORMANCE}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                  </div>
                  <div className='chart-wrapper performance-chart-wrapper'>
                    <Bar
                      data={bar_data}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='padding_bottom_30'>
                {' '}
                <h1 className='section_head padding_bottom_30'>
                  {language.LC().MY_SAVED_ITEM_WITH_FLASH_CARD}
                </h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    {savQuestionTabs.map((tab) => (
                      <Tab
                        key={tab.id}
                        id={tab.id}
                        label={tab.label}
                        isActive={activeTabSaved === tab.id}
                        onClick={this.savedTabToggle}
                      />
                    ))}
                  </ul>
                </div>
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabSaved === '1'
                        ? savedquestion_data
                        : this.state.activeTabSaved === '2'
                          ? savednotes_data
                          : savedvideo_data}
                    </div>
                  </div>
                </div>
              </div>
              {/* ----------------------- Reports ------------- */}

              <div>
                <h1 className='section_head padding_bottom_30'>{language.LC().MY_REPORTS}</h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    {tabs.map((tab) => (
                      <Tab
                        key={tab.id}
                        id={tab.id}
                        label={tab.label}
                        isActive={activeTabReports === tab.id}
                        onClick={this.reportsTabToggle}
                      />
                    ))}
                  </ul>
                </div>

                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabReports === '1'
                        ? question_reportsData
                        : this.state.activeTabReports === '2'
                          ? notes_reportsData
                          : this.state.activeTabReports === '3'
                            ? video_reportsData
                            : cbt_reportsData}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-4'>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().QUESTION_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='1'
                      id='1'
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {qpLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.questionProgressBarFun()}</tbody>
                    )}
                  </table>
                </div>
              </div>
              {/* ------------ Notes Progress Start ------------------------ */}
              <div className='card'>
                <div className='card-header'>
                  {language.LC().NOTES_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='2'
                      id='2'
                      content={this.state.tooltips[2].placement}
                      place_tip={this.state.tooltips[2].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {npLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.notesProgressBarFun()}</tbody>
                    )}
                  </table>
                </div>
              </div>
              {/* ------------------- Notes Progress End ------------------- */}
            </div>
          </div>
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.toggleAlert}
            className={'modal-primary ' + this.props.className}
          >
            <ModalHeader>
              {language.LC().ALERT}
              <button type='button' className='close' aria-label='Close' onClick={this.toggleClose}>
                <span aria-hidden='true'>×</span>
              </button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.toggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>
    );
  }
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
        />
        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

const Tab = ({ id, label, isActive, onClick }) => (
  <li onClick={() => onClick(id)} className={isActive ? 'active' : ''}>
    <span>{label}</span>
  </li>
);
export default Cfa2Dashboard;



// WEBPACK FOOTER //
// ./src/views/CFA2-2025/Dashboard/Cfa2Dashboard.js